import React, { useEffect, useState } from "react";
import axios from "axios";
import type { FormProps } from 'antd';
import { Button, Card, Flex, Form, Input, Radio, Segmented, message, notification } from 'antd';
import R from './picture/R.png'
import { ConfigProvider } from 'antd';
import { CopyOutlined, FileSearchOutlined, LockOutlined, ReconciliationOutlined, UserOutlined } from "@ant-design/icons";
import { initGoogleAnalytics, trackPageView } from './components/analytics';


export function SignIn() {
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [role, setRole] = useState('researcher');
    const [avaliable, setAvalible] = useState<any[]>([]);
    
    type FieldType = {
        username?: string;
        password?: string;
    };


    const Login: FormProps<FieldType>['onFinish'] = async (values) => {
        const data = { username: values.username, password: values.password };
        
        try {
            const response = await axios.post("https://i.vu.ac.th/digitalId/vuapiver1/auth/login.php", data);
    
            if (response.status === 200) {
                const { department, token, user_id, fullname, user_type } = response.data;
                
                if (!department || department.length === 0) {
                    message.error("No departments found for this user.");
                    return;
                }

                await fetchimg(user_id);
                sessionStorage.setItem("token", token);
                sessionStorage.setItem("user", user_id);
                sessionStorage.setItem("fullname", fullname);
                sessionStorage.setItem("user_type", user_type);
    
                if (role === 'examiner') {
                    const availablePositions = await fetchAvailablePositions(department);
    
                    if (availablePositions.length === 0) {
                        message.error("คุณไม่มีสิทธิ์ล็อคอินเข้าสู่ระบบในฐานะผู้อนุมัติ");
                        return;
                    }
    
                    sessionStorage.setItem("role", 'examiner');
                    sessionStorage.setItem("POS_ID", JSON.stringify(availablePositions));
                    if (availablePositions.length > 1) {
                        sessionStorage.setItem("IsMultiplePos", 'yes');
                    } else {
                        sessionStorage.setItem("Fac_ID", availablePositions[0].Fac_ID);
                    }
                    
                    setSuccess(true);
                    setTimeout(() => {
                        window.location.reload();
                    }, 500); 
                    
                    
                } else if (role === 'researcher' ) {
                    sessionStorage.setItem("role", role);
                    sessionStorage.setItem("POS_ID", JSON.stringify(department));
                    if (department.length > 1) {
                        sessionStorage.setItem("IsMultiplePos", 'yes');
                    } else {
                        sessionStorage.setItem("Fac_ID", department[0].Fac_ID);
                    }
                    
                    setSuccess(true);
                    setTimeout(() => {
                        window.location.reload();
                    }, 500); 
                    
                }else if (role === 'commitee'){
                    sessionStorage.setItem("role", role);
                    sessionStorage.setItem("POS_ID", JSON.stringify(department));
                    
                    
                    setSuccess(true);
                    setTimeout(() => {
                        window.location.reload();
                    }, 500); 
                    
                }
                 else if(role === 'staff'){

                    const availablePositions = await fetchifStaff(department);
                    if (availablePositions.length === 0) {
                        message.error("คุณไม่มีสิทธิ์ล็อคอินเข้าสู่ระบบในฐานะเจ้าหน้าที่");
                        return;
                    }

                    const tmpdata = JSON.stringify(availablePositions)
                    sessionStorage.setItem("role", 'staff');
                    sessionStorage.setItem("POS_ID", JSON.stringify(availablePositions));
                    
                    if (availablePositions.length > 1) {
                        sessionStorage.setItem("IsMultiplePos", 'yes');
                    } else {
                        sessionStorage.setItem("Fac_ID", availablePositions[0].Fac_ID);
                    }
                    setSuccess(true);
                    setTimeout(() => {
                        window.location.reload();
                    }, 500); 
                }
                    else {
                    message.error("Invalid role specified.");
                }
            }
        } catch (error) {
            setError(true);
            notification.error({
                message: "เข้าสู่ระบบไม่สำเร็จ",
            });
        }
    };

    

    const fetchimg = async (user:any) =>{
        try{
            console.log(user)
            await axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${user}`).then(res=>
            { 
                
            
              if(res.data){
                console.log(res.data)
                sessionStorage.setItem("user_picture",res.data.userResult[0].picture)
              }else{
                sessionStorage.setItem("test","test")
              }
            }
              
            )}catch (error) {
                console.error("Error fetching position role", error);
            }
    }
    
    const fetchAvailablePositions = async (departments: any) => {
        const availablePositions = [];
        for (const department of departments) {
            try {
                const res = await axios.get(`${process.env.REACT_APP_BASE}/getrole/${department.Pos_ID}`);
                if (res.data.length > 0) {
                    availablePositions.push(department);
                }
            } catch (error) {
                console.error("Error fetching position role", error);
            }
        }
        return availablePositions;
    };

    const fetchifStaff = async (departments:any)=>{
        const availablePositions = [];
            for(const department of departments){
                if(department.Fac_ID==112){
                    availablePositions.push(department);
                    sessionStorage.setItem("PositionName", department.Pos_NameTH);

                }else if(department.Fac_ID==124&&department.Pos_NameTH=='รองอธิการบดีฝ่ายวิจัยและบริการวิชาการ'&&department.Pos_ID=='6'){
                    availablePositions.push(department);
                    sessionStorage.setItem("PositionName", department.Pos_NameTH);
                }
            }
            return availablePositions; 
    }


    const isPrivateMode = async () => {
        return new Promise<boolean>((resolve) => {
          const on = () => resolve(true); // in private
          const off = () => resolve(false); // not in private
      
          if ((window as any).webkitRequestFileSystem) {
            (window as any).webkitRequestFileSystem(
              (window as any).TEMPORARY,
              100,
              off,
              on
            );
          } else {
            off(); // assume not private
          }
        });
      };
      

    useEffect(() => {
        isPrivateMode().then((isPrivate) => {
          if (isPrivate) {
            alert('⚠️ กรุณาอย่าใช้งานในโหมดส่วนตัว (Private Mode) เพื่อไม่ให้หลุดจากระบบ');
          }
        });
      }, []);


    useEffect(()=>{
        const setFavicon = (iconUrl: string) => {
            const link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
            if (link) {
              link.href = iconUrl;
            } else {
              const newLink = document.createElement("link");
              newLink.rel = "icon";
              newLink.href = iconUrl;
              document.head.appendChild(newLink);
            }
          };
      
          // Set external image URL as favicon
          setFavicon("https://www.vu.ac.th/wp-content/uploads/elementor/thumbs/vu-main-logo-02-qtm90eapvkc9aj8bjqi1ltncwx61v3ygsveunoi0mu.png");
          document.title = "VRIIS"; 
    })

    useEffect(() => {
        // Dynamically add the Google Analytics script
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-VTY64G8X7R';
        document.head.appendChild(script);
    
        // Add the inline script
        const inlineScript = document.createElement('script');
        inlineScript.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag() { dataLayer.push(arguments); }
          gtag('js', new Date());
          gtag('config', 'G-VTY64G8X7R');
        `;
        document.head.appendChild(inlineScript);
    
        return () => {
          // Clean up scripts when the component unmounts (optional)
          document.head.removeChild(script);
          document.head.removeChild(inlineScript);
        };
      }, []);

    

    return (
        <ConfigProvider
            theme={{
                components: {
                    Form: { labelColor: 'black' },
                    Segmented: {
                        itemActiveBg: '#D4BDAC',
                        itemSelectedBg: '#FFF1DB',
                        trackBg: 'gray',
                        // itemColor: 'white',
                    },
                },
                token: { fontFamily: 'Kanit' },
            }}
        >
        <title>VRIIS</title>
            {/* <div
                className="bg-slategray"
                style={{
                    backgroundImage: `url(${loginbg})`,
                    height: "110vh",
                    marginTop: "-70px",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className="grid w-full h-full grid-cols-1 box-anim md:grid-cols-2">
                    <div className="relative hidden md:block" style={{ backgroundColor: 'transparent' }}></div>
                    <div
                        className="text-white flex items-center justify-center flex-col"
                        style={{ backgroundColor: 'rgba(52, 52, 52, 0.8)' }}
                    >
                        <Segmented
                            options={['นักวิจัย', 'ผู้บังคับบัญชาเบื้องต้น','เจ้าหน้าที่สำนักวิจัย','คณะกรรมการ']}
                            onChange={(value) => {
                                if(value=='นักวิจัย'){
                                    setRole('researcher');
                                }else if(value=='ผู้บังคับบัญชาเบื้องต้น'){
                                    setRole('examiner');
                                }else if(value=='เจ้าหน้าที่สำนักวิจัย'){
                                    setRole('staff');
                                }
                                else{
                                    setRole('commitee');
                                }
                            }}
                        />
                        <div className="my-4">
                        
                            <h1 className="text-3xl font-semibold">เข้าสู่ระบบ</h1>
                        </div>

                        <p className="text-s" style={{ marginBottom: 20 }}>
                            {role === 'researcher' ? "ในฐานะนักวิจัย" :  role === 'examiner' ? "ในฐานะผู้อนุมัติ": role === 'staff' ? "ในฐานะเจ้าหน้าที่" : 'ในฐานะกรรมการ'}
                        </p>
                        <Form
                            className="text-white"
                            name="basic"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            style={{ maxWidth: 600 }}
                            onFinish={Login}
                            autoComplete="off"
                        >
                            <Form.Item<FieldType>
                                label="Username"
                                name="username"
                                rules={[{ required: true, message: 'Please input your username!' }]}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item<FieldType>
                                label="Password"
                                name="password"
                                rules={[{ required: true, message: 'Please input your password!' }]}
                            >
                                <Input.Password />
                            </Form.Item>

                            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                                <Button type="primary" htmlType="submit">
                                    Submit
                                </Button>
                            </Form.Item>
                        </Form>

                        
                        
                    </div>
                </div>
            </div> */}
            
            <div
                style={{
                    height: '100vh',
                    width: '100vw',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundImage: `url(${R})`,
                    backgroundSize: '100% 100%',  
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                }}
            >
                <div>
                    <Card className="transparent-border-card" 
                    style={{
                        justifyContent: 'center',
                        alignItems: 'center',backgroundColor:'transparent'}}>
                        <p className='text-xl' style={{color:'white',display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',}}>เลือกสถานะในการเข้าสู่ระบบ</p>
                    <Segmented
                        style={{backgroundColor:'white',}}
                            options={['นักวิจัย', 'ผู้บังคับบัญชาเบื้องต้น','เจ้าหน้าที่สำนักวิจัย','คณะกรรมการ']}
                            onChange={(value) => {
                                if(value=='นักวิจัย'){
                                    setRole('researcher');
                                }else if(value=='ผู้บังคับบัญชาเบื้องต้น'){
                                    setRole('examiner');
                                }else if(value=='เจ้าหน้าที่สำนักวิจัย'){
                                    setRole('staff');
                                }
                                else{
                                    setRole('commitee');
                                }
                            }}
                        />
                </Card>
                
                <Card
                bordered={false}
                style={{
                    width: 500,
                    textAlign: 'center',
                    backgroundColor:'#DED4F2'
                    // borderRadius: 8,
                }}
                >
                {/* <Segmented
                            options={['นักวิจัย', 'ผู้บังคับบัญชาเบื้องต้น','เจ้าหน้าที่สำนักวิจัย','คณะกรรมการ']}
                            onChange={(value) => {
                                if(value=='นักวิจัย'){
                                    setRole('researcher');
                                }else if(value=='ผู้บังคับบัญชาเบื้องต้น'){
                                    setRole('examiner');
                                }else if(value=='เจ้าหน้าที่สำนักวิจัย'){
                                    setRole('staff');
                                }
                                else{
                                    setRole('commitee');
                                }
                            }}
                        /> */}
                        <div className="my-4">
                        
                        <h1 className="text-5xl font-semibold" style={{color:'#6f62ae'}}>เข้าสู่ระบบ</h1>
                    </div>
                    <p className="text-xl" style={{ marginBottom: 20,color:'#6f62ae' }}>
                            {role === 'researcher' ? "ในฐานะนักวิจัย" :  role === 'examiner' ? "ในฐานะผู้อนุมัติ": role === 'staff' ? "ในฐานะเจ้าหน้าที่" : 'ในฐานะกรรมการ'}
                        </p>
                        <Form
                            className="text-white"
                            name="basic"
                            // labelCol={{ span: 8 }}
                            // wrapperCol={{ span: 16 }}
                            // style={{ maxWidth: 600 }}
                            onFinish={Login}
                            autoComplete="off"
                        >
                            <Form.Item<FieldType>
                                // label="Username"
                                name="username"
                                
                                rules={[{ required: true, message: 'กรุณากรอกชื่อผู้ใช้งาน' }]}
                            >
                                <Input 
                                size="large" 
                                placeholder="ชื่อผู้ใช้งาน"
                                prefix={<UserOutlined />} />
                            </Form.Item>

                            <Form.Item<FieldType>
                                // label="Password"
                                name="password"
                                rules={[{ required: true, message: 'กรุณากรอกรหัส' }]}
                            >
                                <Input.Password 
                                size="large" 
                                prefix={<LockOutlined />} 
                                placeholder="รหัสผ่าน" 
                                />
                            </Form.Item>

                            <Form.Item 
                            // wrapperCol={{ offset: 8, span: 16 }}
                            >
                                <Button size='large' style={{width:350,color:'white',backgroundColor:'#6d62ae'}}  type="primary" htmlType="submit">
                                    <p className='text-xl'>เข้าสู่ระบบ</p>
                                </Button>
                                <br/>
                                <Button style={{marginTop:10}} onClick={()=>{
                                    window.open('https://drive.google.com/file/d/1AWdnrjyx-Xouct59QOW0PCxWrsb0JyFS/view?usp=drive_link', '_blank');}}>
                                <CopyOutlined />คู่มือการใช้งานนักวิจัย</Button> <br/>
                                <Button style={{marginTop:10}} onClick={()=>{
                                    window.open('https://drive.google.com/file/d/1U71aCIXnG0MHdspgdrjhpAcucql0pJ1s/view?usp=drive_link', '_blank');}}>
                                <ReconciliationOutlined />คู่มือการใช้งานผู้บังคับบัญชาเบื้องต้น</Button>
                                <br/><Button style={{marginTop:10}} onClick={()=>{
                                    window.open('https://drive.google.com/file/d/1xzPQ-sYuMj8tbRZSilFF9TpC2HaHwG4S/view?usp=drive_link', '_blank');}}>
                                <FileSearchOutlined />คู่มือการใช้งานเจ้าหน้าที่สำนักงานวิจัย</Button>
                                <br/><Button style={{marginTop:10}} onClick={()=>{
                                    window.open('https://drive.google.com/file/d/1zDzQilL_GKHi8tl6ixq_LF3t_IL0lFnZ/view?usp=drive_link', '_blank');}}>
                                <UserOutlined />คู่มือการใช้งานคณะกรรมการ</Button>
                            </Form.Item>
                        </Form>

                </Card>
                </div>
            </div>
        </ConfigProvider>
    );
}
